import _ from 'lodash';

export default function initializeTrustedForm() {
    const field = 'xxTrustedFormCertUrl';
    const provideReferrer = false;
    const invertFieldSensitivity = false;
    const tf = document.createElement('script');
    tf.type = 'text/javascript';
    tf.async = true;
    tf.src = _.concat(
        'https://api.trustedform.com/trustedform.js?provide_referrer=',
        escape(provideReferrer),
        '&field=',
        escape(field),
        '&l=',
        new Date().getTime(),
        Math.random(),
        '&invert_field_sensitivity=',
        invertFieldSensitivity
    );
    const s = document.getElementsByTagName('script')[0];
    if (s) {
        s.parentNode.insertBefore(tf, s);
    }
}
